import { ReportTypes } from '../interfaces/report'

/**
 * How many reports are filed under a category or a branch.
 *
 * `Report.category` and `Report.branch` are both `on_delete=SET_NULL` on the
 * backend, so deleting either succeeds and quietly strips the reports that used
 * it of the context they were filed with - nothing warns, and nothing puts it
 * back. Counting here is what lets the delete action be withheld instead.
 *
 * Returns `undefined` while the report list is unknown - still loading, or
 * failed to load. Answering 0 there would offer exactly the delete this guard
 * exists to prevent.
 */
export const countAttachedReports = (
  reports: ReportTypes[] | undefined,
  type: 'category' | 'branch',
  id: number,
): number | undefined =>
  reports?.filter((report) => {
    // A report filed without a branch serialises as `branch: null`, and one
    // whose category is null comes back as a bare `{}` rather than null, so
    // neither can be read as having an id.
    const attached = type === 'category' ? report.category : report.branch
    return attached?.id === id
  }).length
